import React, { Component } from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import _ from 'lodash';
import { generalTemplateSupportedLanguages } from '../../../../../utils/LanguageUtil';
import ArrayUtil from '../../../../../utils/ArrayUtil';
import { intlShape } from '../../../../../components/prop-types';

const messages = defineMessages({
  headerLanguage: {
    id: 'attrs.support_lang.language',
    defaultMessage: 'Languages',
  },
  headerQuestionnaire: {
    id: 'attrs.support_lang.questionnaire',
    defaultMessage: 'Questionnaire',
  },
  headerReport: {
    id: 'attrs.support_lang.report',
    defaultMessage: 'Report',
  },
});
class TemplateMetaData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nodes: [],
    };
  }

  componentDidMount() {
    const { activeLocales, reportActiveLocales } = this.props;
    const nodes = [];

    const generalSupportedLangs = generalTemplateSupportedLanguages(activeLocales, reportActiveLocales);
    if (ArrayUtil.isNotEmpty(generalSupportedLangs)) {
      generalSupportedLangs.forEach((supported) => {
        const quesSupport = activeLocales.find(lang => lang.value === supported.value);
        const reportSupport = reportActiveLocales.find(lang => lang.value === supported.value);
        nodes.push({
          key: supported.value,
          data: {
            language: supported.label,
            questionaire: !!quesSupport,
            report: !!reportSupport,
          },
        });
      });
    }

    this.setState({ nodes: _.sortBy(nodes, node => node.data.language) });
  }

  render() {
    const { intl: { formatMessage } } = this.props;
    const { nodes } = this.state;
    const languageHeader = formatMessage(messages.headerLanguage);
    const questionnaireHeader = formatMessage(messages.headerQuestionnaire);
    const reportHeader = formatMessage(messages.headerReport);

    return (

      <div className="panel panel-padded">
        <div className="panel-body">
          <div className="p-grid mt-25">
            <div className="p-col">
              <TreeTable value={nodes}>
                <Column field="language" header={languageHeader} />
                <Column
                  field="questionaire"
                  header={questionnaireHeader}
                  body={(rowData) => {
                    const { data: { questionaire } } = rowData;
                    return (
                      <div align="center" className="box">
                        {
                          questionaire ? (
                            <i className="fa fa-check icon-success" aria-hidden="true" />
                          )
                            : (
                              <i className="fa fa-minus" aria-hidden="true" />
                            )
                        }
                      </div>
                    );
                  }}
                />
                <Column
                  field="report"
                  header={reportHeader}
                  body={(rowData) => {
                    const { data: { report } } = rowData;
                    return (
                      <div align="center" className="box">
                        {
                          report ? (
                            <i className="fa fa-check icon-success" aria-hidden="true" />
                          )
                            : (
                              <i className="fa fa-minus" aria-hidden="true" />
                            )
                        }
                      </div>
                    );
                  }}
                />
              </TreeTable>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TemplateMetaData.propTypes = {
  activeLocales: PropTypes.arrayOf(PropTypes.any).isRequired,
  reportActiveLocales: PropTypes.arrayOf(PropTypes.any).isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(TemplateMetaData);
